import RecordableView from '@/template/views/RecordableView.vue';
import DeadlineChangeView from '@/template/views/DeadlineChangeView.vue';
import PurposeChangeView from '@/template/views/PurposeChangeView.vue';
import TargetChangeView from '@/template/views/TargetChangeView.vue';
var request = function (request) {
    return { request: request };
};
export var routes = [
    {
        path: '/deadlineChange/:id',
        component: RecordableView,
        props: {
            titleKey: function () { return 'DeadlineChange.Title'; },
            recordableType: "DeadlineChange",
            instructionLinksFactory: function () { return ({ id: "deadlineChange" }); },
            multipleSections: false
        },
        children: [{
                name: 'deadlineChange',
                path: '',
                component: DeadlineChangeView,
                meta: {
                    title: 'DeadlineChange.Title',
                    section: 1,
                    props: request,
                    deletable: true
                }
            }
        ]
    },
    {
        path: '/purposeChange/:id',
        component: RecordableView,
        props: {
            titleKey: function () { return 'PurposeChange.Title'; },
            recordableType: "PurposeChange",
            instructionLinksFactory: function () { return ({ id: "purposeChange" }); },
            multipleSections: false
        },
        children: [
            {
                name: 'purposeChange',
                path: '',
                component: PurposeChangeView,
                meta: {
                    title: 'PurposeChange.Title',
                    section: 1,
                    props: request,
                    deletable: false
                }
            }
        ]
    },
    {
        path: '/targetChange/:id',
        component: RecordableView,
        props: {
            titleKey: function () { return 'TargetChange.Title'; },
            recordableType: "TargetChange",
            instructionLinksFactory: function () { return ({ id: "targetChange" }); },
            multipleSections: false
        },
        children: [
            {
                name: 'targetChange',
                path: '',
                component: TargetChangeView,
                meta: {
                    title: 'TargetChange.Title',
                    section: 1,
                    props: request,
                    deletable: false
                }
            }
        ]
    }
];
